import { Dispatch } from "redux";
import { appendRole, removeRole, setFoucusedRole, setRoles, setRoleScreens, setShowAddRoleModal } from './reducer'
import RoleFields from "Components/organisms/forms/role-form/types";
import { toast } from "react-toastify";
import Role from "models/role";
import Screen from "models/screen";

export const getRoles = () => async (dispatch: Dispatch) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/roles`
        const res = await fetch(url, {
            credentials: 'include'
        });

        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }

        dispatch(setRoles((await res.json()).data))
        return true;
    } catch (err: any) {
        console.error('Error fetching documents:', err);
        return [];
    }
}

export const submitRoleForm = (data: RoleFields) => async (dispatch: Dispatch) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/roles`
        const res = await fetch(url, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!res.ok) {
            const errBody = await res.json()
            toast.error(errBody.message);
            return []
        }
        const resData = (await res.json()).data

        const role: Role = resData.role

        dispatch(appendRole(resData.role))
        dispatch(setShowAddRoleModal(false))
        toast.success("Role created!")
        return true;
    } catch (err: any) {
        toast.error("Error submitting role")
        return [];
    }
}

export const updateRole = (data: Role, assignedScreens: Screen[]) => async (dispatch: Dispatch) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/roles/${data.id}`
        const res = await fetch(url, {
            method: 'PUT',
            credentials: 'include',
            body: JSON.stringify({
                name: data.name,
                screenCodes: assignedScreens.map(s => s.code)
            }),
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!res.ok) {
            const errBody = await res.json()
            toast.error(errBody.message);
            return
        }

        const resData = (await res.json()).data
        const { role, screens } = resData

        dispatch(setRoleScreens({
            role, screens
        }))
        dispatch(setFoucusedRole(null));
        toast.success("Role updated!")
    } catch (err: any) {
        console.error(err)
        toast.error("Error updating role")
    }
}


export const deleteRole = (data: Role) => async (dispatch: Dispatch) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/roles/${data.id}`
        const res = await fetch(url, {
            method: 'DELETE',
            credentials: 'include',
        });

        if (!res.ok) {
            const errBody = await res.json()
            toast.error(errBody.message);
            return
        }


        dispatch(removeRole(data))
        dispatch(setFoucusedRole(null));
        toast.success("Role deleted!")
    } catch (err: any) {
        console.error(err)
        toast.error("Error updating role")
    }
}